class FostrPLPInfiniteScroll extends HTMLElement {
  constructor() {
    super();
  }
}

class FostrPLPProducts extends FostrPLPInfiniteScroll {
  pages = 1;

  constructor() {
    super();
  }

  connectedCallback() {
    // Split UL list by 24 items to create pages
    this.splitListIntoPages();
    this.setLoadPreviousButtonVisibility();
    this.scrollToProductCard();

    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
  }

  setLoadPreviousButtonVisibility() {
    if (this.pages > 1) {
      // Set load previous button to visible
      var loadPreviousButton = document.querySelector(
        "fostr-plp-load-previous"
      );
      loadPreviousButton?.classList.add("isVisible");
    }
  }

  scrollToProductCard() {
    // check if #pid= is in the URL
    if (!window.location.href.includes("#pid=")) {
      return;
    }

    // get the product id from the URL
    const productId = window.location.href.split("#pid=")[1];
    const productCard = document.querySelector(
      `fostr-card-media-swipe[data-product-id="${productId}"]`
    );
    if (!productCard) {
      return;
    }

    // turn off smooth scrolling
    document.documentElement.classList.add("noSmoothScroll");

    // scroll to the product card
    setTimeout(() => {
      const headerEl = document.querySelector("#shopify-section-fostr-header");

      if (headerEl) {
        const yOffset = 0; //headerEl.getBoundingClientRect().height * -1;
        const y =
          productCard.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset;

        // replace scroll history with y position
        window.history.replaceState(null, null, `#pid=${productId}`);

        window.scrollTo({ top: y, behavior: "instant" });
      }

      // turn on smooth scrolling
      document.documentElement.classList.remove("noSmoothScroll");
    }, 0);
  }

  splitListIntoPages() {
    // Get the UL list
    var list = this.querySelector("ul");

    // Get the LI items
    var items = this.querySelectorAll("ul.plp-product-grid > li");
    var newList = null;
    var newDiv = null;

    // Loop through the LI items
    for (var i = 0; i < items.length; i++) {
      // If the current item is divisible by 12
      if (i % 12 === 0) {
        // If the current item is not the first item
        if (i !== 0) {
          this.pages++;

          // Append the new UL list to the DOM
          this.appendChild(newList);
        }

        // Create a new UL list
        newList = document.createElement("ul");
        newList.setAttribute("data-fostr-collection-container", "");
        //newList.setAttribute('data-id', 'template--15918820196507__product-grid');
        // set data-page-id attribute

        // copy the classes from the old list
        newList.className = list.className;
      }

      // Add data page attribute to the current item fostr-card-media-swipe
      items[i]
        .querySelector("fostr-card-media-swipe")
        ?.setAttribute("data-page", this.pages);

      // Append the LI item to the new UL list
      newList.appendChild(items[i]);
    }

    // loop through the last list of items and and remove loading attribute from img tags
    var imgs = newList.querySelectorAll("img");

    // mobile, 2 columns
    var lazyLoadItemsCount = 4;
    // tablet, 4 columns
    if (window.innerWidth >= 990) {
      lazyLoadItemsCount = 8;
    }

    // desktop, 4 columns
    if (window.innerWidth >= 1440) {
      lazyLoadItemsCount = 8;
    }

    // if PLP or Search page
    for (var i = 0; i < imgs.length; i++) {
      if (i >= lazyLoadItemsCount) {
        break;
      }

      imgs[i].removeAttribute("loading");
      imgs[i].setAttribute("fetchpriority", "high");
    }

    // add class to the last list item, others are added in the loop above
    newList.classList.add("isVisible");

    // Append the new UL list to the DOM
    this.appendChild(newList);

    // Remove the old UL list
    list.remove();
  }
}

class FostrPLPLoadMore extends FostrPLPInfiniteScroll {
  constructor() {
    super();
  }

  connectedCallback() {
    // Uncomment this to enable infinite scroll
    // this.setIntersectionObserver();

    // handle click event
    this.addEventListener("click", this.handleClick.bind(this));
  }

  setIntersectionObserver() {
    // set delay so that the intersection observer doesn't fire on page load
    setTimeout(() => {
      // Create an observer
      var observer = new IntersectionObserver(
        (entries, observer) => {
          // If the load more button is in view, then click it
          if (entries[0].isIntersecting) {
            // trigger click event
            this.click();
          }
        },
        {
          threshold: 1,
        }
      );

      // Observe the load more button
      observer.observe(this);
    }, 2000);
  }

  updateURLPageNumber() {
    // get current page number from the pg query param
    const url = new URL(window.location.href);
    let currentPageNumber = parseInt(url.searchParams.get("page"));
    if (isNaN(currentPageNumber)) {
      currentPageNumber = 1;
    }

    // if the current page number is greater than 1, then update the pg query param
    if (currentPageNumber >= 1) {
      url.searchParams.set("page", currentPageNumber + 1);
      window.history.replaceState({}, "", url);
      return;
    }
  }

  async handleClick() {
    let nextLink = document.querySelector(
      "nav.pagination a.pagination__next-item"
    );
    if (!nextLink) {
      return;
    }

    // add loading class to load more button, remove hidden class from spinner
    this.classList.add("loading");
    this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

    let nextPage = await this.fetchPageParts(nextLink.href);
    let nextPageProducts = nextPage.products;
    // page number from nextLink.href
    let pageNumber = nextLink.href.split("page=")[1];

    const currentUlClassList = document.querySelector(
      "fostr-plp-products > ul"
    ).classList;
    nextPageProducts = nextPageProducts.replace(
      "<ul ",
      '<ul data-page="' + pageNumber + '" '
    );
    // replace ul class with current ul class
    nextPageProducts = nextPageProducts.replace(
      'class="',
      'class="' + currentUlClassList + " "
    );

    // prepend html to fostr-plp-products
    let productList = document.querySelector("fostr-plp-products");
    // add nextItems to end productList element
    productList.insertAdjacentHTML("beforeend", nextPageProducts);
    // replace pagination
    document.querySelector("nav.pagination").innerHTML = nextPage.pagination;

    nextLink = document.querySelector("nav.pagination a.pagination__next-item");
    if (!nextLink) {
      this.remove();
    }

    // update the url
    this.updateURLPageNumber();

    // remove loading class from load more button, add hidden class to spinner
    this.classList.remove("loading");
    this.querySelector(".loading-overlay__spinner").classList.add("hidden");

    // Focus first new element
    const newUl = productList.querySelector(`ul[data-page="${pageNumber}"]`);
    if (newUl) {
      const firstNewElement = newUl.querySelector("li");
      if (firstNewElement) {
        // Make the element focusable by adding tabindex
        firstNewElement.setAttribute("tabindex", "-1");
        setTimeout(() => {
          firstNewElement.focus({ preventScroll: true });
        }, 100);
      }
    }
  }

  async fetchPageParts(url) {
    return await fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        // return fostr-plp-products element from responseText
        const products = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector("fostr-plp-products").innerHTML;
        const pagination = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector("nav.pagination").innerHTML;

        return {
          products,
          pagination,
        };
      });
  }
}

class FostrPLPLoadPrevious extends FostrPLPInfiniteScroll {
  constructor() {
    super();
  }

  connectedCallback() {
    // handle click
    this.addEventListener("click", this.handleClick.bind(this));
  }

  async fetchPageParts(url) {
    return await fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        // return fostr-plp-products element from responseText
        const products = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector("fostr-plp-products").innerHTML;
        const pagination = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector("nav.pagination").innerHTML;

        return {
          products,
          pagination,
        };
      });
  }

  async handleClick() {
    // fetch previous products
    const previousLink = document.querySelector(
      "nav.pagination a.pagination__previous-item"
    );
    if (!previousLink) {
      return;
    }

    // add loading class to load more button, remove hidden class from spinner
    this.classList.add("loading");
    this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

    let previousPage = await this.fetchPageParts(previousLink.href);
    let previousPageProducts = previousPage.products;

    // get page number from previousLink
    const pageNumber = previousLink.href.split("page=")[1];

    const currentUlClassList = document.querySelector(
      "fostr-plp-products > ul"
    ).classList;
    previousPageProducts = previousPageProducts.replace(
      "<ul ",
      '<ul data-page="' + pageNumber + '" '
    );
    // replace ul class with current ul class
    previousPageProducts = previousPageProducts.replace(
      'class="',
      'class="' + currentUlClassList + " "
    );

    // prepend html to fostr-plp-products
    let productList = document.querySelector("fostr-plp-products");
    // add previousItems before productList element
    productList.insertAdjacentHTML("afterbegin", previousPageProducts);
    // replace pagination
    document.querySelector("nav.pagination").innerHTML =
      previousPage.pagination;

    // turn off smooth scrolling
    document.documentElement.classList.add("noSmoothScroll");

    const lastVisibleUlEl = document.querySelector("fostr-plp-products > ul");
    if (lastVisibleUlEl) {
      window.scrollTo({
        top: lastVisibleUlEl.getBoundingClientRect().height,
      });
    }

    // turn on smooth scrolling
    document.documentElement.classList.remove("noSmoothScroll");

    if (pageNumber === "1") {
      this.remove();
    }

    // update the url
    //this.updateURLPageNumber();

    // remove loading class from load more button, add hidden class to spinner
    this.classList.remove("loading");
    this.querySelector(".loading-overlay__spinner").classList.add("hidden");
  }
}

customElements.define("fostr-plp-products", FostrPLPProducts);
customElements.define("fostr-plp-load-next", FostrPLPLoadMore);
customElements.define("fostr-plp-load-previous", FostrPLPLoadPrevious);
